<p-panel>
  <div
    *ngIf="reaReviewNotice !== ''"
    class="rea-review-form-notice"
    role="status"
    aria-live="polite"
  >
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>Revisión REA pendiente</strong>
      <p>{{ reaReviewNotice }}</p>
    </div>
  </div>

  <ng-container *ngIf="isReactiveFormReady; else reactiveFormLoadingState">
    <app-reactive-form-support-data-readiness
      [items]="parcelasSupportDataReadinessItems"
      [severity]="parcelasSupportDataReadinessSeverity"
      [summary]="parcelasSupportDataReadinessSummary"
      [title]="parcelasSupportDataReadinessTitle"
      [visible]="isReactiveFormReady"
    >
    </app-reactive-form-support-data-readiness>

    <app-reactive-form-builder
      #formbuilder
      (stableValueChanges)="stableValueChanges($event)"
      (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
      (goBack)="goBack()"
      (afterSend)="afterSend($event)"
      [form]="form.formFields"
      [serverUrl]="''"
      [id]="reactiveFormRecordId"
      [request]="request"
      [getRequest]="getRequest"
      [previousData]="initialPreviousData"
      [undoEnabled]="undoEnabled"
    >
    </app-reactive-form-builder>
  </ng-container>
</p-panel>

<ng-template #reactiveFormLoadingState>
  <div class="p-3 text-center" role="status" aria-live="polite">
    <div *ngIf="!reactiveFormLoadingError" class="text-muted">
      {{ reactiveFormLoadingLabel }}
    </div>
    <div *ngIf="reactiveFormLoadingError" class="alert alert-danger mb-0" role="alert">
      {{ reactiveFormLoadingError }}
    </div>
  </div>
</ng-template>

<p-dialog
  [header]="'Mapa ' + form.parcelaNombre"
  [(visible)]="form.mapaAbierto"
  #mapaDialog
  (onShow)="handleMapDialogShown()"
  [style]="{ width: '80vw' }"
  [appendTo]="'body'"
  [modal]="true"
  [style]="{'height': '75vh', 'width': '80vw'}"
>
  <div class="relative w-100 h-100">
    <app-mapa-add
      *ngIf="form.mapaAbierto || shouldRenderMapDialog"
      [origin]="origin"
      [finca]="form.finca"
      [localidad]="form.localidad"
      [cultivo]="form.cultivo"
      [variedad]="form.variedad"
      [parcelaNombre]="form.parcelaNombre"
      (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
</p-dialog>

<app-dialog-sigpac-form
  #sigpac
  (sendSigPac)="getSigPac($event)"
></app-dialog-sigpac-form>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <div [formGroup]="comunidadForm" class="p-fluid">
    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>
